import ShowAllSelectionsButton from './_show-all-selections-button.js'
import MarketLayoutDescriptors from './_market-layout-descriptors.js'
import FlexPane from './_flex-pane.js'
import Market from './_market.js'
import MenuRow from './_menu-row.js'
import Text from './_text.js'

export default {
  name: 'GoalScorerMarketContent',
  values: {
    enableResponsiveMarketGroups: true,
    showAllSelectionsButton: {
      configSet: ShowAllSelectionsButton,
      configValues: {},
    },
    layoutDescriptors: {
      configSet: MarketLayoutDescriptors,
      configValues: {},
    },
    container: {
      configSet: FlexPane,
      configValues: {
        style: {
          flexDirection: 'column',
          padding: '8px',
        },
      },
    },
    innerContainer: {
      configSet: FlexPane,
      configValues: {},
    },
    marketsContainer: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '4px',
        style: {
          justifyContent: 'flex-end',
          minWidth: 0,
        },
      },
    },
    market: {
      configSet: Market,
      configValues: {
        direction: 'column',
        container: {
          style: {
            minWidth: '64px',
            maxWidth: '320px',
            _mobile_minWidth: '60px',
            _mobile_maxWidth: '120px',
          },
        },
        selectionsGroupContainer: {
          style: {
            width: '100%',
          },
        },
        selectionButton: {
          view: {
            nameDisplay: 'hide',
            _mobile_nameDisplay: 'hide',
            layoutDirection: 'horizontalAlignCenter',
          },
        },
      },
    },
    menuItem: {
      configSet: MenuRow,
      configValues: {
        item: {
          unselected: {
            style: {
              base: {
                flexGrow: 0,
                flexBasis: '40px',
                padding: '0 8px',
              },
            },
          },
          selected: {
            style: {
              base: {
                flexGrow: 0,
                flexBasis: '40px',
                padding: '0 8px',
              },
            },
          },
        },
      },
    },
    playersContainer: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '4px',
        style: {
          flexDirection: 'column',
          flexGrow: 1,
          flexBasis: '208px',
          _mobile_flexBasis: '128px',
          minWidth: '208px',
          _mobile_minWidth: '128px',
          padding: '32px 0 0 0',
        },
      },
    },
    playerNameContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          height: '44px',
          padding: '2px 0',
          boxSizing: 'border-box',
          flexGrow: '0',
          flexDirection: 'column',
          justifyContent: 'center',
        },
      },
    },
    playerNameHeader: {
      configSet: Text,
      configValues: {
        truncate: true,
        container: {
          flexGrow: 0,
        },
      },
    },
    teamNameHeader: {
      configSet: Text,
      configValues: {
        truncate: true,
      },
    },
    numberOfExpandedRows: 8,
  },
  meta: {
    extendable: false,
  },
}
